
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "103px",
    "height": "50px",
    "viewBox": "0 0 103 50",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "B35CDFAB-B1E6-4906-9317-BEADBDE75D7B"
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "控件",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "扫地车"
          },
          "children": [
            {
              "tag": "polygon",
              "attrsMap": {
                "id": "矩形",
                "fill": "#FFFFFF",
                "transform": "translate(84.466868, 39.090909) rotate(-4.000000) translate(-84.466868, -39.090909) ",
                "points": "79.4668675 36.3636364 89.4668675 36.3636364 89.4668675 39.4476843 87.521346 40.2579051 86.6914295 41.8181818 79.4668675 41.8181818"
              }
            },
            {
              "tag": "circle",
              "attrsMap": {
                "id": "椭圆形",
                "stroke": "#FFFFFF",
                "stroke-width": "2",
                "cx": "18.6363636",
                "cy": "23.1818182",
                "r": "11.2727273"
              }
            },
            {
              "tag": "line",
              "attrsMap": {
                "x1": "0.454545455",
                "y1": "48.6363636",
                "x2": "101.363636",
                "y2": "48.6363636",
                "id": "直线-5",
                "stroke": "#FFFFFF",
                "stroke-width": "2",
                "stroke-linecap": "square"
              }
            },
            {
              "tag": "polygon",
              "attrsMap": {
                "id": "矩形",
                "fill": "#FFFFFF",
                "transform": "translate(88.018446, 34.466860) rotate(-24.000000) translate(-88.018446, -34.466860) ",
                "points": "86.2002645 30.8304959 89.8366281 30.8304959 89.8366281 38.1032231 86.2002645 38.1032231"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M92.1808564,37.3636364 C94.2871662,37.3636364 95.7269535,37.5643611 96.6522528,38.0156597 C96.9970598,38.1838333 97.2541077,38.3840308 97.420028,38.6369314 C97.5939376,38.9020096 97.6622623,39.2158813 97.6748984,39.5666742 C97.6949933,40.1245352 99.1819748,42.0056277 100.010164,43.0122149 C99.5704747,43.337916 98.7944421,43.6305926 97.9683841,43.9311624 C96.4614986,44.4794584 94.5741358,44.9055451 92.8487128,45.025797 C91.5761258,45.1144888 89.0520397,44.7151896 86.9508653,44.1915659 C85.9673774,43.9464755 85.0762921,43.6735813 84.4557708,43.4009131 C84.2687111,42.7189973 86.2440331,40.5589622 86.2440331,39.896618 C86.2440331,39.5583725 86.3333366,39.2438337 86.5259017,38.9657687 C86.7419859,38.6537418 87.0745372,38.3914416 87.5114121,38.1689376 C88.542997,37.6435428 90.0851473,37.3636364 92.1808564,37.3636364 Z",
                "id": "椭圆形",
                "stroke": "#FFFFFF",
                "stroke-width": "2",
                "transform": "translate(92.194140, 41.200232) rotate(-26.000000) translate(-92.194140, -41.200232) "
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M49.3759585,1 L49.3759585,43.5454545 L43.6027798,43.5454545 C43.3300073,44.1332244 43.1345807,44.5391765 43.0129025,44.7614283 C42.6565262,45.412369 42.2182981,45.8778132 41.9323357,46.1616578 C41.6517712,46.4401444 41.2797568,46.7785177 40.7005124,47.1355902 C40.568145,47.2171874 40.3383265,47.3321014 40.0134779,47.4846402 C39.7373741,47.6042416 39.5041997,47.6936948 39.3109469,47.7508135 C38.9435618,47.8602873 38.673978,47.9432392 38.3958951,47.9937954 C37.9879815,48.067955 37.5531599,48.0909091 37.3079927,48.0909091 C36.8616026,48.0909091 36.2100892,48.0704744 35.4533592,47.887478 C35.2375034,47.8352786 34.911188,47.7131322 34.4718166,47.5298215 C33.7716796,47.2655191 33.1344944,46.8246218 32.5177301,46.2103018 C31.716537,45.412284 31.1597721,44.5267553 30.8598211,43.5454545 L30.8598211,43.5454545 L26.3478445,43.5454545 L18.6486857,41.2817282 L18.6486857,34.5924325 C20.3345858,34.4924322 21.5777854,34.2802289 22.3843498,33.9791761 C23.3400469,33.6224591 24.227855,33.1845136 25.0061242,32.6528546 C26.3652536,31.7243924 27.3941523,30.6118388 27.9211628,29.9126197 C28.6202905,28.9850416 29.144226,27.9747412 29.516473,26.8135544 C29.7401277,26.1158864 29.9020038,25.4676637 29.9979721,24.66403 C30.0536585,24.1977147 30.1201022,23.5254909 30.0764751,23.0259029 C29.9961095,22.0348511 29.9472042,21.4460135 29.8663944,20.9540314 C29.6752529,19.7903333 29.3029385,18.9123911 28.8766066,18.0226524 C28.5730047,17.3890467 28.131884,16.6753627 27.5304515,15.9556917 C27.1111828,15.4539969 26.6093967,14.9463167 26.0404222,14.4716741 C25.4373874,13.9685054 24.8143726,13.4622628 24.0904207,13.1191312 C22.9960402,12.5902941 21.7999081,12.0202565 20.0949642,11.7408745 C19.7106581,11.6778999 19.1050162,11.6579238 18.2769797,11.6919686 L18.2769797,11.6919686 L15.5454545,5.66923835 L15.5454545,2.47894166 L17.9332854,1 L49.3759585,1 Z",
                "id": "矩形",
                "stroke": "#FFFFFF",
                "stroke-width": "2"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M79.4809805,0.999999992 C79.9997183,5.75960048 80.3711716,10.7019906 80.5954865,15.8271588 C80.8284093,21.1490028 80.4443822,30.3884528 79.449248,43.5454532 L79.449248,43.5454532 L72.7658367,43.5454545 C72.3492936,44.3197228 72.0351309,44.8685405 71.8181155,45.1885895 C71.6681967,45.409686 71.4761364,45.6493055 71.2437249,45.9088398 C70.797116,46.3420731 70.4446511,46.6553006 70.1820067,46.843086 C69.9241188,47.0274706 69.5761778,47.2319172 69.1402742,47.4598492 C68.633512,47.6680733 68.2402,47.8116897 67.9587787,47.885716 C67.6791001,47.9592838 67.2727283,48.0263903 66.7406964,48.0921155 C66.389239,48.0988614 66.143576,48.0995887 66.0037723,48.0922748 C65.0353247,47.978832 64.6732368,47.9046782 64.2712038,47.795815 C63.7787115,47.5803311 63.4311803,47.423307 63.2289212,47.3240871 C62.9035072,47.1644525 62.6381032,47.0194596 62.4341767,46.8865959 C62.0610844,46.6435158 61.6677695,46.292291 61.2481658,45.8404351 C60.9476736,45.4706387 60.7300638,45.1828976 60.5990713,44.9746418 C60.4016997,44.6608545 60.1532099,44.1833477 59.8478495,43.5454545 L59.8478495,43.5454545 L55.921413,43.5454545 L55.921413,1 Z",
                "id": "矩形",
                "stroke": "#FFFFFF",
                "stroke-width": "2"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M76.7292143,4.63636364 C77.3929287,9.33635203 77.7251604,13.8855442 77.7251604,18.2839934 C77.7251604,22.7877737 77.491684,28.6826228 77.0256588,35.9685636 L77.0256588,35.9685636 L74.7610078,35.9685636 C73.47399,31.7414358 71.8169459,29.0719171 69.9158068,27.8400495 C66.5681939,25.6709205 63.1397141,25.5543128 61.3759585,25.68133 L61.3759585,25.68133 L61.3759585,4.63636364 Z",
                "id": "矩形",
                "stroke": "#FFFFFF",
                "stroke-width": "2"
              }
            },
            {
              "tag": "circle",
              "attrsMap": {
                "id": "椭圆形",
                "stroke": "#FFFFFF",
                "stroke-width": "2",
                "cx": "37.1941403",
                "cy": "41.3636364",
                "r": "6.72727273"
              }
            },
            {
              "tag": "circle",
              "attrsMap": {
                "id": "椭圆形",
                "stroke": "#FFFFFF",
                "stroke-width": "2",
                "cx": "66.2850494",
                "cy": "41.3636364",
                "r": "6.72727273"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "d": "M55.7395948,32.8181818 L55.7395948,39.9090909 L49.5577766,39.9090909 L49.5577766,32.8181818 L55.7395948,32.8181818 Z",
                "id": "矩形",
                "stroke": "#FFFFFF",
                "stroke-width": "2"
              }
            },
            {
              "tag": "g",
              "attrsMap": {
                "id": "修理",
                "transform": "translate(10.909091, 15.454545)",
                "fill-rule": "nonzero"
              },
              "children": [
                {
                  "tag": "rect",
                  "attrsMap": {
                    "id": "矩形",
                    "fill": "#000000",
                    "opacity": "0",
                    "x": "0",
                    "y": "1.81818182",
                    "width": "14.5454545",
                    "height": "14.5454545"
                  }
                },
                {
                  "tag": "path",
                  "attrsMap": {
                    "d": "M5.45974431,10.9090909 C5.1463048,10.9090909 4.83286529,10.8827928 4.51942578,10.8280051 C3.40814025,10.6351523 2.39768141,10.1113817 1.5976435,9.31148092 C0.786646169,8.50062263 0.260593846,7.47718797 0.0742836477,6.3507524 C-0.107642781,5.24842342 0.0457891469,4.13294539 0.521428122,3.12704281 L0.720889628,2.70408159 L4.08981638,6.07243077 L6.07128013,4.09130672 L2.70235338,0.720766038 L3.12538712,0.521338728 C4.13146219,0.0457812967 5.24713149,-0.107624326 6.34964949,0.0742709124 C7.47627821,0.260549169 8.50208024,0.786511305 9.31088569,1.5973696 C10.1109236,2.39727035 10.634784,3.40755595 10.8276699,4.51865096 C11.016172,5.60563937 10.8758914,6.70796835 10.4221712,7.70729641 L9.82378671,7.4355493 C10.6435516,5.62755446 10.2512042,3.46672669 8.84620614,2.06196948 C7.53107533,0.747064144 5.57372231,0.319719909 3.84651718,0.933342401 L7.00063924,4.08692371 L4.08981638,7.00163054 L0.933502442,3.84585773 C0.319774732,5.57276674 0.747192245,7.52978419 2.06232305,8.84468953 C3.46732113,10.2494467 5.62632754,10.6417268 7.43682429,9.8221025 L7.70861799,10.4203844 C6.99625547,10.7447277 6.2334796,10.9090909 5.45974431,10.9090909 Z M12.1480892,14.5454545 C11.8830848,14.5454545 11.6180804,14.4447655 11.4167592,14.2433875 L7.36362994,10.189113 C7.24242638,10.0678752 7.24242638,9.87266177 7.36362994,9.75347884 C7.48483351,9.63224104 7.67999178,9.63224104 7.79914105,9.75347884 L11.8522703,13.8077533 C12.0145598,13.9700887 12.2795642,13.9700887 12.4418537,13.8077533 L13.8059074,12.4433143 C13.8839707,12.3652289 13.927111,12.2604301 13.927111,12.1474118 C13.927111,12.0364484 13.8839707,11.9316496 13.8059074,11.8515094 L9.75483241,7.79928978 C9.63362885,7.67805198 9.63362885,7.48283856 9.75483241,7.36365563 C9.87603598,7.24241782 10.0711943,7.24241782 10.1903435,7.36365563 L14.2434728,11.4179301 C14.4386311,11.6131435 14.5454545,11.8720582 14.5454545,12.1494667 C14.5454545,12.4268752 14.4386311,12.6857899 14.2434728,12.8810033 L12.8794191,14.2454423 C12.6760437,14.4447655 12.4130936,14.5454545 12.1480892,14.5454545 Z",
                    "id": "形状",
                    "stroke": "#FFFFFF",
                    "fill": "#FFFFFF"
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  